import { BookingModule } from './site/booking/booking.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbCarousel, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PageComponent } from './shared/page/page.component';
import { HeaderComponent } from './shared/layout/header/header.component';
import { NavbarComponent } from './shared/layout/navbar/navbar.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { TokenStorage } from './token.storage';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { PagesModule } from './pages/pages.module';
import { ToastsContainer } from './toast-global/toasts-container.component';
import { PoliciesComponent } from './policies/policies.component';
import { BookingComponent } from './site/booking/booking.component';


@NgModule({
  declarations: [
    AppComponent,
    PageComponent,
    HeaderComponent,
    FooterComponent,
    NavbarComponent,
    ToastsContainer,
    PoliciesComponent,
    BookingComponent,
  ],

  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    Ng2TelInputModule,
    NgbModule,
    FormsModule,
    PagesModule,
    ReactiveFormsModule,
    BookingModule,
    ReactiveFormsModule,
  ],
  providers: [
    TokenStorage,
    // { provide: LocationStrategy, useClass: HashLocationStrategy 

  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
